import React from "react";
import styles from "./Pag404.module.css";

const Pag404 = () => {
  return (
    <div className={styles.pag}>
      <h1 className={styles.error}>#404</h1>
      <h2>Página não encontrada</h2>
      <p>Retorne a página inicial.</p>
    </div>
  );
};

export default Pag404;
